import { render, staticRenderFns } from "./Dashboard-v3.vue?vue&type=template&id=0c85fb69&"
import script from "./Dashboard-v3.vue?vue&type=script&lang=js&"
export * from "./Dashboard-v3.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard-v3.vue?vue&type=style&index=0&id=0c85fb69&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports